import React, {useState, useEffect} from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import SelectInfinite from '../../components/FormFields/SelectInfinite';
import InputText from '../../components/FormFields/InputText';
import TextArea from '../../components/FormFields/Textarea';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {Col, Row} from 'react-bootstrap';
import {
  getPotentionalRisks,
  getAllSubProcesses,
  editLitigation,
  getAllSubCategories,
  getRiskFile,
  getAllSubCauses,
  GetPotentionalRisk,
} from '../../services/litigationService';
import SelectList from '../../components/select/SelectList';
import './Litigation.scss';
import {useUserContext} from '../../contexts/UserContext';
import Toast from '../../components/toast/Toast';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import Trash from './img/trash.svg';
import 'antd/dist/antd.css';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import DownloadOutlined from '@ant-design/icons/lib/icons/DownloadOutlined';
import {validDouble} from '../../utils/const';
import allowedFileTypes from '../../utils/allowedFileTypes';
import PreventTransitionPrompt from '../../components/preventTransitionprompt/PreventTransition';
import {format} from 'date-fns';

const Litigation = ({defaultData}) => {
  const lang = getLanguage();
  const user = useUserContext();
  const userDepartment = useDepartmentContext();

  const bankLegitimationSelected = () => {
    if (defaultData.bankLegitimation === 'PLAINTIFF') {
      return bankLegitimation[1];
    } else {
      return bankLegitimation[0];
    }
  };

  const [disabledRisk, setDisabledRisk] = useState(true);
  const [disableSubprocess, setDisableSubPorcess] = useState(true);
  const [subProcesses, setSubProcesses] = useState([]);
  const [potentionalRisks, setPotentionalRisks] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [subCauses, setSubCauses] = useState([]);
  const [disableSubCategory, setDisableSubCategory] = useState(true);
  const [litigation, setLitigation] = useState({
    id: defaultData.id,
    potentialRisk: {
      value: defaultData.risk.potentialRiskId,
      label:
        lang === 'eng'
          ? defaultData.risk.potentialRiskTitle
          : defaultData.risk.potentialRiskTitle,
    },
    title: defaultData.risk.title,
    description: defaultData.risk.description,
    typeGainLoss: {
      value: defaultData.risk.typeGainLossId,
      label:
        lang === 'eng'
          ? defaultData.risk.typeGainLossNameEn
          : defaultData.risk.typeGainLossName,
    },
    riskCause: {
      value: defaultData.risk.riskCauseId,
      label:
        lang === 'eng'
          ? defaultData.risk.riskCauseNameEn
          : defaultData.risk.riskCauseName,
    },
    riskSubCause: {
      value: defaultData.risk.riskSubCauseId,
      label:
        lang === 'eng'
          ? defaultData.risk.riskSubCauseNameEn
          : defaultData.risk.riskSubCauseName,
    },
    process: {
      value: defaultData.risk.processId,
      label:
        lang === 'eng'
          ? defaultData.risk.processNameEn
          : defaultData.risk.processName,
    },
    subprocess: {
      value: defaultData.risk.subprocessId,
      label:
        lang === 'eng'
          ? defaultData.risk.subprocessNameEn
          : defaultData.risk.subprocessName,
    },
    category: {
      value: defaultData.risk.riskCategoryId,
      label:
        lang === 'eng'
          ? defaultData.risk.riskCategoryNameEn
          : defaultData.risk.riskCategoryName,
    },
    subcategory: {
      value: defaultData.courtSubcategoryRiskId,
      label:
        lang === 'eng'
          ? defaultData.courtSubcategoryRiskNameEn
          : defaultData.courtSubcategoryRiskName,
    },
    businessLine: {
      value: defaultData.risk.businessLineId,
      label:
        lang === 'eng'
          ? defaultData.risk.businessLineNameEn
          : defaultData.risk.businessLineName,
    },
    methodology: {
      value: defaultData.risk.methodologyId,
      label:
        lang === 'eng'
          ? defaultData.risk.methodologyNameEn
          : defaultData.risk.methodologyName,
    },
    departmentStakeholder: {
      value: defaultData.risk.departmentStakeholderId,
      label:
        lang === 'eng'
          ? defaultData.risk.departmentStakeholderNameEn
          : defaultData.risk.departmentStakeholderName,
    },
    estimatedGrossLost: defaultData.risk.estimatedGrossLost,
    comment: defaultData.risk.comment,
    typeCourtDispute: defaultData.typeCourtDispute,
    bankLegitimation: bankLegitimationSelected,
    commissioner: defaultData.commissioner,
    startingDateDispute: defaultData.startingDateDispute,
    subjectDispute: defaultData.subjectDispute,
    jurisdiction: defaultData.jurisdiction,
    valueCourtDispute: defaultData.valueCourtDispute,
    provisionAmount: defaultData.provisionAmount,
    feeReservation: defaultData.feeReservation,
    lossDispute: defaultData.lossDispute,
    subjectStatus: defaultData.subjectStatus,
    courtId: defaultData.id,
    riskId: defaultData.risk.id,
    riskStatusId: defaultData.risk.riskStatusId,
    files: defaultData.risk.files,
    riskDateCreated: defaultData.risk.dateCreated,
    riskStatus:
      lang === 'eng'
        ? defaultData.risk.riskStatusNameEn
        : defaultData.risk.riskStatusName,
    departmentSource:
      lang === 'eng'
        ? defaultData.risk.departmentSourceNameEn
        : defaultData.risk.departmentSourceName,
    userInChargeRisk:
      defaultData.risk.userInChargeFirstName +
      ' ' +
      defaultData.risk.userInChargeLastName,
    responsibleUserRisk:
      defaultData.risk.userResponsibleFirstName +
      ' ' +
      defaultData.risk.userResponsibleLastName,
    riskEstimationId: defaultData.risk.riskEstimationId,
  });
  const [files, setFiles] = useState([]);
  const [deleteFiles, setDeleteFiles] = useState([]);
  const [riskEstimation, setRiskEstimation] = useState(null);
  const [departmentOptions, setDepartmentOptions] = useState([]);

  const bankLegitimation = [
    {value: 'RESPONDENT', label: lang === 'eng' ? 'Respondent' : 'Tuženi'},
    {value: 'PLAINTIFF', label: lang === 'eng' ? 'Plaintiff' : 'Tužilac'},
  ];

  const [schema, setSchema] = useState(
    yup.object().shape({
      title: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(100, t('message.max', {max: 100})),
      description: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(2048, t('message.max', {max: 2048})),
      riskCauseId: yup.object().nullable().required(t('message.fieldRequired')),
      departmentStakeholderId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      courtCategory: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      subCategory: yup.object().nullable().required(t('message.fieldRequired')),
      // userResponsibleId: yup.object().nullable().required(t('message.fieldRequired')),
      estimatedGrossLost: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .matches(validDouble, t('message.onlyDecimalNumbers'))
        .max(20, t('message.max', {max: 20})),
      methodologyId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      comment: yup
        .string()
        .trim()
        .max(2048, t('message.max', {max: 2048})),
      typeCourtDispute: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      bankLegitimation: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      proxyInfo: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      litigationDate: yup
        .string()
        .nullable()
        .required(t('message.fieldRequired')),
      disputeSubject: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      jurisdiction: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      litigationValue: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .matches(validDouble, t('message.onlyDecimalNumbers'))
        .max(20, t('message.max', {max: 20})),
      provisionAmount: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .matches(validDouble, t('message.onlyDecimalNumbers'))
        .max(20, t('message.max', {max: 20})),
      reimbursementProvision: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .matches(validDouble, t('message.onlyDecimalNumbers'))
        .max(20, t('message.max', {max: 20})),
      litigationLoss: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .matches(validDouble, t('message.onlyDecimalNumbers'))
        .max(20, t('message.max', {max: 20})),
      subjectStatus: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      process: yup.string().nullable().required(t('message.fieldRequired')),
      subprocessId: yup
        .string()
        .nullable()
        .required(t('message.fieldRequired')),
      riskSubCause: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
    })
  );

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, setValue} = methods;
  const watchProcess = watch('process');
  const watchCategory = watch('courtCategory');
  const watchRiskCause = watch('riskCauseId');
  const watchSubprocess = watch('subprocessId');
  const watchPotentialRisk = watch('riskType');

  const fetchSubprocesses = async () => {
    try {
      const {data} = await getAllSubProcesses(watchProcess['value']);
      return data;
    } catch (e) {}
  };

  const fetchSubCategories = async () => {
    try {
      const {data} = await getAllSubCategories(watchCategory['value']);
      return data;
    } catch (e) {}
  };

  const fetchPotentionalRisks = async () => {
    try {
      const {data} = await getPotentionalRisks();
      return data;
    } catch (e) {}
  };
  const fetchSubcauses = async () => {
    try {
      const {data} = await getAllSubCauses(watchRiskCause['value']);
      // setSubProcesses(data);
      return data;
    } catch (e) {}
  };

  useEffect(() => {
    window.location.pathname.includes('edit')
      ? setDisabledRisk(false)
      : setDisabledRisk(true);
  }, []);

  useEffect(() => {
    if (watchCategory) {
      fetchSubCategories().then((r) => {
        if (window.location.pathname.includes('edit')) {
          setDisableSubCategory(false);
        }
        let subCategories = [];
        r.forEach((item) => {
          subCategories.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubCategories(subCategories);
      });
    }
    if (watchCategory === null) {
      setDisableSubCategory(true);
      setValue('subCategory', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchCategory]);

  useEffect(() => {
    if (watchRiskCause?.value) {
      fetchSubcauses().then((r) => {
        let subCauses = [];
        r.forEach((item) => {
          subCauses.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubCauses(subCauses);
      });
    }
    if (watchRiskCause === null) {
      setValue('riskSubCause', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchRiskCause]);

  useEffect(() => {
    if (watchProcess) {
      fetchSubprocesses().then((r) => {
        if (window.location.pathname.includes('edit')) {
          setDisableSubPorcess(false);
        }
        let subProcesses = [];
        r.forEach((item) => {
          subProcesses.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubProcesses(subProcesses);
      });
    }
    if (watchProcess === null) {
      setValue('subprocessId', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchProcess]);

  useEffect(() => {
    fetchPotentionalRisks().then((r) => {
      let options = [];
      r.forEach((item) => {
        options.push({
          value: item.id,
          label: item.title,
        });
      });
      setPotentionalRisks(options);
    });
    let departmentsArray = [];
    userDepartment.forEach((item) => {
      departmentsArray.push({
        id: item.id,
        name: lang === 'eng' ? item.nameEn : item.name,
      });
    });
  }, []);

  useEffect(() => {
    if (watchPotentialRisk) {
      const fetchPotentialRiskData = async () => {
        try {
          const {data} = await GetPotentionalRisk(watchPotentialRisk?.value);
          setRiskEstimation(data[0].riskEstimationId);
        } catch (e) {
          // console.log(e);
        }
      };
      fetchPotentialRiskData();
    }
  }, [watchPotentialRisk]);

  useEffect(() => {
    let departmentsArray = [];
    userDepartment.forEach((item) => {
      departmentsArray.push({
        value: item.id,
        label: lang === 'eng' ? item.nameEn : item.name,
      });
      setDepartmentOptions(departmentsArray);
    });
  }, []);

  const handleCancel = (e) => {
    e.preventDefault();
    window.location = `/court-risk/${defaultData.id}`;
  };

  const submitForm = async (data) => {
    const files = document.getElementById('upload').files;
    const date =
      format(new Date(data.litigationDate), 'yyyy-MM-dd') +
      'T' +
      format(new Date(data.litigationDate), 'hh:mm:ss');
    const payload = {
      id: parseInt(litigation.courtId),
      courtSubcategoryRiskId: data.subCategory.value,
      typeCourtDispute: data.typeCourtDispute,
      bankLegitimation: data.bankLegitimation.value,
      commissioner: data.proxyInfo,
      startingDateDispute: date,
      subjectDispute: data.disputeSubject,
      jurisdiction: data.jurisdiction,
      valueCourtDispute: data.litigationValue,
      provisionAmount: data.provisionAmount,
      feeReservation: data.reimbursementProvision,
      lossDispute: data.litigationLoss,
      subjectStatus: data.subjectStatus,
      dateCreated: defaultData.dateCreated,
      risk: {
        id: parseInt(litigation.riskId),
        riskStatusId: litigation.riskStatusId,
        departmentSourceId: userDepartment[0].id,
        active: true,
        riskCategoryId: 3,
        applicationDate: new Date(),
        userInChargeId: user.id,
        userInChargeLogin: user.login,
        userResponsibleId: userDepartment[0].userResponsibleId,
        userResponsibleLogin: userDepartment[0].userResponsibleLogin,
        potentialRiskId: data.riskType ? data.riskType.value : null,
        title: data.title,
        description: data.description,
        typeGainLossId: data.typeGainLossId ? data.typeGainLossId.value : null,
        methodologyId: data.methodologyId.value,
        riskCauseId: data.riskCauseId.value,
        riskSubCauseId: data.riskSubCause.value,
        departmentStakeholderId: data.departmentStakeholderId.value,
        courtCategoryId: data.courtCategory.value,
        processId: watchProcess['value'],
        subprocessId: watchSubprocess['value'],
        estimatedGrossLost: data.estimatedGrossLost,
        comment: data.comment ? data.comment : '',
        businessLineId: data.businessLineId ? data.businessLineId.value : null,
        userCreatedId: user.id,
        deleteFiles: deleteFiles,
        riskEstimationId: riskEstimation,
        dateCreated: defaultData.risk.dateCreated,
      },
    };

    try {
      const response = await editLitigation(payload, files);
      if (response.status === 200) {
        await Toast.fire({
          title: t('litigation.messages.editSuccess'),
          icon: 'success',
        });
        window.location = `/court-risk/${parseInt(litigation.id)}`;
      }
    } catch (err) {
      Toast.fire({
        title: t('litigation.messages.editError'),
        icon: 'error',
      });
    }
  };

  const uploadOnChange = () => {
    const input = document.getElementById('upload');
    let children = [];
    if (input.files.length > 10) {
      Toast.fire({
        title: t('message.tooManyFiles'),
        icon: 'error',
      });
    } else {
      for (let i = 0; i < input.files.length; ++i) {
        if (input.files.item(i).size > 10485760) {
          Toast.fire({
            title: t('message.fileTooBig'),
            icon: 'error',
          });
        } else {
          children.push({
            id: input.files.item(i).name,
            label: input.files.item(i).name,
          });
          setFiles(children);
        }
      }
    }
  };

  const clearFetchedFile = (id) => {
    let children = litigation.files.filter((file) => file.id !== id);
    setLitigation({...litigation, ['files']: children});
    setDeleteFiles([...deleteFiles, id]);
  };

  const clearLocalFile = (index) => {
    const dt = new DataTransfer();
    const input = document.getElementById('upload');
    const {files} = input;
    let children = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (index !== i) {
        dt.items.add(file); // here you exclude the file
        children.push({
          id: input.files.item(i).name,
          label: input.files.item(i).name,
        });
      }
    }
    input.files = dt.files;
    setFiles(children);
  };

  const onChangeReimbursementProvision = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('reimbursementProvision', result);
  };

  const onChangeLitigationLoss = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('litigationLoss', result);
  };

  const onChangeProvisionAmount = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('provisionAmount', result);
  };

  const onChangeLitigationValue = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('litigationValue', result);
  };

  const onChangeEstimatedGrossLost = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('estimatedGrossLost', result);
  };

  return (
    <>
      {defaultData !== undefined && (
        <>
          <PreventTransitionPrompt when={!disabledRisk} />
          <div className="form mt-4 w-100">
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(submitForm)}>
                <Row className="field-group-title">
                  <Col className="col-4 col-xl-2">
                    {t('litigation.mainData')}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.potentionalRisk')}
                    </label>
                    <span className="optional register">
                      {t('common.optional')}
                    </span>
                    <SelectList
                      name="riskType"
                      placeholder={t('litigation.placeholder.potentionalRisk')}
                      options={potentionalRisks}
                      isClearable
                      selected={
                        litigation.potentialRisk !== undefined &&
                        litigation.potentialRisk.value
                          ? litigation.potentialRisk
                          : ''
                      }
                      isDisabled={disabledRisk}
                    />
                    <label className="label-litigation">
                      {t('litigation.title')}
                    </label>
                    <InputText
                      type="text"
                      name="title"
                      defaultValue={litigation.title}
                      className="form-control input-field"
                      placeholder={t('litigation.placeholder.title')}
                      disabled={disabledRisk}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.description')}
                    </label>
                    <TextArea
                      name="description"
                      defaultValue={litigation.description}
                      className={`form-control text-area `}
                      placeholder={t('litigation.placeholder.description')}
                      disabled={disabledRisk}
                    />
                  </Col>
                </Row>
                <Row className="mt-5 field-group-title">
                  <Col className="col-6 col-xl-3">
                    {t('litigation.additionalInformation')}
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col className="col-3 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.category')}
                    </label>
                    <SelectInfinite
                      api="court-category-risks"
                      name="courtCategory"
                      selected={
                        litigation.category !== undefined &&
                        litigation.category.value
                          ? litigation.category
                          : ''
                      }
                      placeholder={t('litigation.placeholder.category')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabledRisk}
                    />
                    <label className="label-litigation">
                      {t('litigation.subCategory')}
                    </label>
                    <SelectList
                      name="subCategory"
                      isDisabled={disableSubCategory}
                      selected={
                        litigation.subcategory !== undefined &&
                        litigation.subcategory.value
                          ? litigation.subcategory
                          : ''
                      }
                      placeholder={t('litigation.placeholder.subCategory')}
                      options={subCategories}
                      key={litigation.category}
                      isClearable
                    />
                    <label className="label-litigation">
                      {t('litigation.riskCauses')}
                    </label>
                    <SelectInfinite
                      api="risk-causes"
                      name="riskCauseId"
                      selected={
                        litigation.riskCause !== undefined &&
                        litigation.riskCause.value
                          ? litigation.riskCause
                          : ''
                      }
                      placeholder={t('litigation.placeholder.riskCauses')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabledRisk}
                    />
                  </Col>
                  <Col className="col-3 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.riskSubCause')}
                    </label>
                    <SelectList
                      name="riskSubCause"
                      isDisabled={disabledRisk}
                      className="select"
                      placeholder={t('litigation.placeholder.riskSubCause')}
                      options={subCauses}
                      selected={
                        litigation.riskSubCause !== undefined &&
                        litigation.riskSubCause.value
                          ? litigation.riskSubCause
                          : ''
                      }
                      placeholder={t('litigation.placeholder.riskCauses')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabledRisk}
                      isClearable
                    />
                    <label className="label-litigation">
                      {t('litigation.businessLines')}
                    </label>
                    <span className="optional register">
                      {t('common.optional')}
                    </span>
                    <SelectInfinite
                      api="business-lines"
                      name="businessLineId"
                      selected={
                        litigation.businessLine !== undefined &&
                        litigation.businessLine.value
                          ? litigation.businessLine
                          : ''
                      }
                      placeholder={t('litigation.placeholder.businessLines')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabledRisk}
                    />
                    <label className="label-litigation">
                      {t('litigation.process')}
                    </label>
                    <SelectInfinite
                      api="processes"
                      name="process"
                      defaultValue={
                        litigation.process !== undefined &&
                        litigation.process.value
                          ? litigation.process
                          : ''
                      }
                      placeholder={t('litigation.placeholder.process')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabledRisk}
                    />
                  </Col>
                  <Col className="col-3 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.subprocess')}
                    </label>
                    <SelectList
                      name="subprocessId"
                      isDisabled={disableSubprocess}
                      selected={
                        litigation.subprocess !== undefined &&
                        litigation.subprocess.value
                          ? litigation.subprocess
                          : ''
                      }
                      placeholder={t('litigation.placeholder.subprocess')}
                      options={subProcesses}
                      key={litigation.process}
                      isClearable
                    />
                    <label className="label-litigation">
                      {t('litigation.estimatedGrossLoss')}
                    </label>
                    <InputText
                      type="number"
                      name="estimatedGrossLost"
                      defaultValue={litigation.estimatedGrossLost}
                      className="form-control input-field"
                      placeholder={t(
                        'litigation.placeholder.estimatedGrossLoss'
                      )}
                      disabled={disabledRisk}
                      step=".01"
                      min="0"
                      onChange={onChangeEstimatedGrossLost}
                    />
                    <label className="label-litigation">
                      {t('litigation.metodologies')}
                    </label>
                    <SelectInfinite
                      api="methodologies"
                      name="methodologyId"
                      selected={
                        litigation.methodology !== undefined &&
                        litigation.methodology.value
                          ? litigation.methodology
                          : ''
                      }
                      placeholder={t('litigation.placeholder.metodologies')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabledRisk}
                    />
                  </Col>
                  <Col className="col-3 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.responsibleUser')}
                    </label>
                    <SelectInfinite
                      api="users"
                      name="userResponsibleId"
                      labelKey="firstName"
                      placeholder={t('ilitigation.placeholder.responsibleUser')}
                      className="select"
                      isDisabled={true}
                      defaultValue={{
                        value: defaultData.risk.userResponsibleId,
                        label:
                          defaultData.risk.userResponsibleFirstName +
                          ' ' +
                          defaultData.risk.userResponsibleLastName,
                      }}
                    />
                    <label className="label-litigation">
                      {t('litigation.department')}
                    </label>
                    <SelectList
                      name="departmentStakeholderId"
                      selected={
                        litigation.departmentStakeholder !== undefined &&
                        litigation.departmentStakeholder.value
                          ? litigation.departmentStakeholder
                          : ''
                      }
                      options={departmentOptions}
                      className="select"
                      placeholder={t('litigation.placeholder.department')}
                      isDisabled={disabledRisk}
                    />
                    <label className="label-litigation">
                      {t('litigation.typeGainLoss')}
                    </label>
                    <span className="optional register">
                      {t('common.optional')}
                    </span>
                    <SelectInfinite
                      api="type-gain-losses"
                      name="typeGainLossId"
                      selected={
                        litigation.typeGainLoss !== undefined &&
                        litigation.typeGainLoss.value
                          ? litigation.typeGainLoss
                          : ''
                      }
                      placeholder={t('litigation.placeholder.typeGainLoss')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabledRisk}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.additionalComment')}
                    </label>

                    <TextArea
                      name="comment"
                      defaultValue={litigation.comment}
                      className={`form-control text-area `}
                      placeholder={t(
                        'litigation.placeholder.additionalComment'
                      )}
                      disabled={disabledRisk}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    {!disabledRisk ? (
                      // Adding new files
                      <>
                        <label
                          className="label-litigation"
                          htmlFor={'attachFile'}
                        >
                          {t('litigation.attachFiles')}
                        </label>
                        <span className="optional register">
                          {t('common.optional')}
                        </span>
                        <InputText
                          id="upload"
                          type="file"
                          name="file"
                          multiple
                          disabled={disabledRisk}
                          className="file-input"
                          onChange={uploadOnChange}
                          accept={allowedFileTypes}
                        />
                        <ul className="mb-0" key={litigation}>
                          {litigation.files.map((file) => (
                            <li key={file.id}>
                              <div className="d-flex align-items-center">
                                <span className="mr-2">{file.fileName}</span>
                                {disabledRisk ? (
                                  <DownloadOutlined
                                    onClick={() => {
                                      getRiskFile(file.id, file.fileName);
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={Trash}
                                    alt="trash"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      clearFetchedFile(file.id);
                                    }}
                                  />
                                )}
                              </div>
                            </li>
                          ))}
                        </ul>
                        <ul key={files}>
                          {files.map((file, index) => (
                            <li key={file.id}>
                              <div className="d-flex align-items-center">
                                <span className="mr-2">{file.label}</span>
                                <img
                                  src={Trash}
                                  alt="trash"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    clearLocalFile(index);
                                  }}
                                />
                              </div>
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : (
                      // Editing files
                      <div>
                        {litigation.files.length > 0 ? (
                          <>
                            <label className="label-litigation">
                              {t('litigation.attachedFiles')}
                            </label>
                            <span className="optional register">
                              {t('common.optional')}
                            </span>

                            <div>
                              <ul>
                                {litigation.files.map((file) => (
                                  <li key={file.id}>
                                    <div className="d-flex align-items-center">
                                      <span className="mr-2">
                                        {file.fileName}
                                      </span>
                                      <DownloadOutlined
                                        onClick={() => {
                                          getRiskFile(file.id, file.fileName);
                                        }}
                                      />
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </>
                        ) : null}
                      </div>
                    )}
                  </Col>
                </Row>
                <Row className="mt-5 field-group-title">
                  <Col className="col-4 col-xl-2">
                    {t('litigation.litigationInfo')}
                  </Col>
                </Row>
                <Row>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.typeCourtDispute')}
                    </label>
                    <InputText
                      type="text"
                      name="typeCourtDispute"
                      defaultValue={litigation.typeCourtDispute}
                      className="form-control input-field"
                      placeholder={t('litigation.placeholder.typeCourtDispute')}
                      disabled={disabledRisk}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label
                      className="label-litigation"
                      htmlFor="bankLegitimation"
                    >
                      {t('litigation.bankLegitimation')}
                    </label>
                    <SelectList
                      name="bankLegitimation"
                      isDisabled={disabledRisk}
                      selected={litigation.bankLegitimation}
                      placeholder={t('litigation.placeholder.bankLegitimation')}
                      options={bankLegitimation}
                      isClearable
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.proxyInfo')}
                    </label>
                    <InputText
                      type="text"
                      name="proxyInfo"
                      defaultValue={litigation.commissioner}
                      className="form-control input-field"
                      placeholder={t('litigation.placeholder.proxyInfo')}
                      disabled={disabledRisk}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3 d-flex flex-column">
                    <label className="label-litigation">
                      {t('litigation.litigationDate')}
                    </label>
                    <InputDate
                      name="litigationDate"
                      defaultValue={new Date(litigation.startingDateDispute)}
                      placeholder={t('litigation.placeholder.litigationDate')}
                      style={{height: '45px!important'}}
                      disabled={disabledRisk}
                      maxDate={new Date()}
                      isClearable={disabledRisk ? false : true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.disputeSubject')}
                    </label>
                    <InputText
                      type="text"
                      name="disputeSubject"
                      defaultValue={litigation.subjectDispute}
                      className="form-control input-field"
                      placeholder={t('litigation.placeholder.disputeSubject')}
                      disabled={disabledRisk}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.jurisdiction')}
                    </label>
                    <InputText
                      type="text"
                      name="jurisdiction"
                      defaultValue={litigation.jurisdiction}
                      className="form-control input-field line-height"
                      placeholder={t('litigation.placeholder.jurisdiction')}
                      disabled={disabledRisk}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.litigationValue')}
                    </label>
                    <InputText
                      type="number"
                      name="litigationValue"
                      defaultValue={litigation.valueCourtDispute}
                      className="form-control input-field"
                      placeholder={t('litigation.placeholder.litigationValue')}
                      disabled={disabledRisk}
                      step=".01"
                      min="0"
                      onChange={onChangeLitigationValue}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.provisionAmount')}
                    </label>
                    <InputText
                      type="number"
                      name="provisionAmount"
                      defaultValue={litigation.provisionAmount}
                      className="form-control input-field line-height"
                      placeholder={t('litigation.placeholder.provisionAmount')}
                      disabled={disabledRisk}
                      step=".01"
                      min="0"
                      onChange={onChangeProvisionAmount}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.reimbursementProvision')}
                    </label>
                    <InputText
                      type="number"
                      name="reimbursementProvision"
                      defaultValue={litigation.feeReservation}
                      className="form-control input-field line-height"
                      placeholder={t(
                        'litigation.placeholder.reimbursementProvision'
                      )}
                      disabled={disabledRisk}
                      step=".01"
                      min="0"
                      onChange={onChangeReimbursementProvision}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.litigationLoss')}
                    </label>
                    <InputText
                      type="number"
                      name="litigationLoss"
                      defaultValue={litigation.lossDispute}
                      className="form-control input-field line-height"
                      placeholder={t('litigation.placeholder.litigationLoss')}
                      disabled={disabledRisk}
                      step=".01"
                      min="0"
                      onChange={onChangeLitigationLoss}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.subjectStatus')}
                    </label>
                    <InputText
                      type="text"
                      name="subjectStatus"
                      defaultValue={litigation.subjectStatus}
                      className="form-control input-field"
                      placeholder={t('litigation.placeholder.subjectStatus')}
                      disabled={disabledRisk}
                    />
                  </Col>
                </Row>
                <Row className="mt-5 field-group-title">
                  <Col className="col-6 col-xl-3">
                    {t('litigation.systemAddedInformation')}
                  </Col>
                </Row>
                <Row>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.id')}
                    </label>
                    <InputText
                      type="text"
                      name="id"
                      defaultValue={litigation.riskId}
                      className="form-control input-field"
                      disabled={true}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3 d-flex flex-column">
                    <label className="label-litigation">
                      {t('litigation.dateCreated')}
                    </label>
                    <InputDate
                      name="dateCreated"
                      defaultValue={new Date(litigation.riskDateCreated)}
                      style={{height: '45px!important'}}
                      disabled={true}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.status')}
                    </label>
                    <InputText
                      type="text"
                      name="riskStatus"
                      defaultValue={litigation.riskStatus}
                      className="form-control input-field"
                      disabled={true}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.department')}
                    </label>
                    <InputText
                      type="text"
                      name="departmentSource"
                      defaultValue={litigation.departmentSource}
                      className="form-control input-field"
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.userInChargeRisk')}
                    </label>
                    <InputText
                      type="text"
                      name="userInChargeRisk"
                      defaultValue={litigation.userInChargeRisk}
                      className="form-control input-field"
                      disabled={true}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3 mb-5">
                    <label className="label-litigation">
                      {t('litigation.responsibleUserRisk')}
                    </label>
                    <InputText
                      type="text"
                      name="responsibleUserRisk"
                      defaultValue={litigation.responsibleUserRisk}
                      className="form-control input-field"
                      disabled={true}
                    />
                  </Col>
                </Row>
                <div>
                  {!disabledRisk ? (
                    <Row className="form-footer w-100" key={disabledRisk}>
                      <button
                        className="secondary-btn"
                        type="reset"
                        onClick={handleCancel}
                      >
                        {t('buttons.cancel')}
                      </button>
                      <button className="primary-btn">
                        {t('buttons.save')}
                      </button>
                    </Row>
                  ) : null}
                </div>
              </form>
            </FormProvider>
          </div>
        </>
      )}
    </>
  );
};

export default Litigation;
